// Shared pending count + invalidation listeners (WS-driven, no polling)

import { fetchStructureChangeRequests } from '../pages/private/admin/organisationMembersTabs/requests/structureChangeRequestsApi';

let pendingCount = 0;
let pendingFetchPromise = null;
const countSubscribers = new Set();
const invalidateSubscribers = new Set();

const notifyCount = () => {
  countSubscribers.forEach((cb) => cb());
};

const notifyInvalidate = () => {
  invalidateSubscribers.forEach((cb) => cb());
};

export function getPendingStructureChangeRequestsCount() {
  return pendingCount;
}

export function setPendingStructureChangeRequestsCount(next) {
  const value = Math.max(0, Number(next) || 0);
  if (value === pendingCount) return;
  pendingCount = value;
  notifyCount();
}

/** Sync badge from list response counts (no extra HTTP). */
export function syncPendingCountFromListCounts(counts) {
  if (counts && typeof counts.pending === 'number') {
    setPendingStructureChangeRequestsCount(counts.pending);
  }
}

export function subscribePendingStructureChangeRequestsCount(cb) {
  countSubscribers.add(cb);
  return () => countSubscribers.delete(cb);
}

export function subscribeStructureChangeRequestsInvalidate(cb) {
  invalidateSubscribers.add(cb);
  return () => invalidateSubscribers.delete(cb);
}

export function invalidateStructureChangeRequestsList() {
  notifyInvalidate();
}

/** Single in-flight pending fetch (dedupes Strict Mode + parallel callers). */
export async function fetchPendingCountOnce() {
  if (pendingFetchPromise) {
    return pendingFetchPromise;
  }

  pendingFetchPromise = (async () => {
    try {
      const data = await fetchStructureChangeRequests('pending');
      if (!data?.ok) return pendingCount;

      const next =
        typeof data.counts?.pending === 'number'
          ? data.counts.pending
          : Array.isArray(data.items)
            ? data.items.length
            : 0;

      setPendingStructureChangeRequestsCount(next);
      return next;
    } catch {
      return pendingCount;
    } finally {
      pendingFetchPromise = null;
    }
  })();

  return pendingFetchPromise;
}
